import * as React from 'react';
import { ReactReduxContext } from './Context';
import { createSubscription } from '../utils/Subscription';
import { useIsomorphicLayoutEffect } from '../utils/useIsomorphicLayoutEffect';
function Provider(_ref) {
  var store = _ref.store,
    context = _ref.context,
    children = _ref.children,
    serverState = _ref.serverState,
    _ref$stabilityCheck = _ref.stabilityCheck,
    stabilityCheck = _ref$stabilityCheck === void 0 ? 'once' : _ref$stabilityCheck,
    _ref$noopCheck = _ref.noopCheck,
    noopCheck = _ref$noopCheck === void 0 ? 'once' : _ref$noopCheck;
  var contextValue = React.useMemo(function () {
    var subscription = createSubscription(store);
    return {
      store: store,
      subscription: subscription,
      getServerState: serverState ? function () {
        return serverState;
      } : undefined,
      stabilityCheck: stabilityCheck,
      noopCheck: noopCheck
    };
  }, [store, serverState, stabilityCheck, noopCheck]);
  var previousState = React.useMemo(function () {
    return store.getState();
  }, [store]);
  useIsomorphicLayoutEffect(function () {
    var subscription = contextValue.subscription;
    subscription.onStateChange = subscription.notifyNestedSubs;
    subscription.trySubscribe();
    if (previousState !== store.getState()) {
      subscription.notifyNestedSubs();
    }
    return function () {
      subscription.tryUnsubscribe();
      subscription.onStateChange = undefined;
    };
  }, [contextValue, previousState]);
  var Context = context || ReactReduxContext; // @ts-ignore 'AnyAction' is assignable to the constraint of type 'A', but 'A' could be instantiated with a different subtype

  return /*#__PURE__*/React.createElement(Context.Provider, {
    value: contextValue
  }, children);
}
export default Provider;